var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconBoomArmDown = function SvgIconBoomArmDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M6.602 3.25a.5.5 0 0 0-1 0v8.535a3.5 3.5 0 0 0-3 3.465v2c0 .955.382 1.82 1.002 2.451v.049a3.107 3.107 0 0 0 3.107 3.107h6.696c.182.239.47.393.794.393h1a1 1 0 1 0 0-2h-1a1 1 0 0 0-.92.607h-6.57c-.91 0-1.686-.577-1.98-1.386a3.5 3.5 0 0 0 4.871-3.221v-2a3.5 3.5 0 0 0-3-3.465zM4.604 19.252a2.5 2.5 0 0 0 3.998-2.002v-2a2.5 2.5 0 0 0-5 0v2c0 .818.392 1.544 1 2h.002z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.435 13a.5.5 0 0 1 0 .5l-1.498 2.6a.5.5 0 0 1-.87 0l-1.498-2.6a.5.5 0 0 1 .433-.749h1.101a7.5 7.5 0 0 0-6.036-7.357.5.5 0 0 1 .195-.98 8.5 8.5 0 0 1 6.841 8.336l.899.001a.5.5 0 0 1 .433.25"
  })));
};
export default SvgIconBoomArmDown;